












import { computed, defineComponent } from '@vue/composition-api';
import { useGlobals }                from '@/hooks/use-globals';
import { Computed }                  from '@/types';

export default defineComponent({
  name: 'cUsersTableHead',
  setup() {
    const { store, i18n } = useGlobals();
    const columns: Computed<string[]> = computed((): string[] => store.state.views.vUsers.table.columns);

    return {
      i18n,
      columns,
    };
  },
});
